import store from '@js/store'

export default []
